import { IconButton } from '@coolblue-development/freddy';
import styled from '@emotion/styled';
const StyledIconButton = styled(IconButton) `
  padding: 0 !important;

  &:disabled {
    pointer-events: none;
    cursor: not-allowed;
  }
`;
export { StyledIconButton };
//# sourceMappingURL=styled.js.map